import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";

import { report_receipt_tax, report_receipt, report_contract } from "../../../components/Report.js";
export default class PaymentLists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",
      filter_payment_type: "",
      filter_start_date: "",
      filter_end_date: "",

      data: [],
      count: 10,
      data_bank: [],

      id: "",
      uid: "",
      bank_name: "",
      account_number: "",
      account_name: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const { filter_search, filter_start_date, filter_end_date } = this.state;
    let data, count, data_bank;
    loading(true);
    let [result, result_bank] = await Promise.all([
      GET("admin/sales/list", {
        page: page,
        data_search: filter_search,
        start_date: filter_start_date,
        end_date: filter_end_date,
        status_code: "เสร็จสิ้น,ใบแจ้งหนี้",
      }),
      GET("admin/setting/banks/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }

    if (result_bank?.status) {
      data_bank = result_bank.data
        .map((e) => ({
          value: e.id,
          label: `${e.bank_name} : ${e.account_number} (${e.account_name})`,
          is_default: e.is_default, // เก็บไว้ใช้ sort
        }))
        .sort((a, b) => (b.is_default === true) - (a.is_default === true));
    }
    this.setState({
      data,
      count,
      data_bank
    });
    loading(false);
  };
  Print = async (uid, document_no, item) => {
    const { data_bank } = this.state;
  loading(true);
  let result = await GET("admin/sales/list-payment", {
    data_search: document_no,
  });

  if (result?.status) {
    const item = result.data;

    let cash_amount = 0;
    let transfer_amount = 0;
    let credit_amount = 0;

    for (const payment of item.filter(e => e.sale || e.repair)) {
      cash_amount += Number(payment.cash_amount || 0);
      transfer_amount += Number(payment.transfer_amount || 0);
      credit_amount += Number(payment.credit_amount || 0);
    }

    Swal.fire({
      title: "พิมพ์เอกสาร",
      html: `
        <div class="w-100">
          <button id="report-receipt-tax" class="btn btn-outline-dark w-100 mb-3 text-start">
            <span class="icon me-2">&#xf15b;</span>
            ใบเสร็จรับเงิน/ใบกำกับภาษี
          </button>
          <button id="report-receipt" class="btn btn-outline-dark w-100 mb-3 text-start">
            <span class="icon me-2">&#xf15b;</span>
            ใบเสร็จรับเงิน
          </button>
          <button id="report-contract" class="btn btn-outline-dark w-100 mb-3 text-start">
            <span class="icon me-2">&#xf15b;</span>
            ใบสัญญา
          </button>
        </div>
      `,
      showConfirmButton: false,
      showCloseButton: true,
      didOpen: () => {
        document.getElementById("report-receipt-tax").addEventListener("click", () => {
          report_receipt_tax(uid, {
            cash_amount: cash_amount,
            transfer_amount: transfer_amount,
            transfer_bank_account: "",
            transfer_date: "",
            transfer_time: "",
            credit_amount: credit_amount,
            credit_bank_account: "",
            credit_date: "",
            check_number: "",
          });
        });
        document.getElementById("report-receipt").addEventListener("click", () => {
          report_receipt(uid, {
            cash_amount: cash_amount,
            transfer_amount: transfer_amount,
            transfer_bank_account: "",
            transfer_date: "",
            transfer_time: "",
            credit_amount: credit_amount,
            credit_bank_account: "",
            credit_date: "",
            check_number: "",
          });
        });
        document.getElementById("report-contract").addEventListener("click", () => {
          report_contract(uid, {cash_amount, transfer_amount, credit_amount});
        });
        
      },
    });

    loading(false);
  }
};


  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "ยกเลิกข้อมูล",
        "ยืนยันการยกเลิกรายการนี้หรือไม่ ?",
        "ยกเลิกข้อมูล",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let result = await PUT("admin/sales/update/" + id, {
        status: "ยกเลิก",
      });
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  render() {
    const {
      modal_create,
      modal_update,
      filter_search,
      filter_payment_type,
      filter_start_date,
      filter_end_date,
      data,
      count,
      id,
      uid,
      bank_name,
      account_number,
      account_name,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">รายการชำระเงิน</h4>
            </div>
            <div className="d-flex flex-wrap align-items-center">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">วันที่เอกสาร</td>
                    <td className="text-nowrap">เลขที่เอกสาร</td>
                    <td className="text-nowrap">ลูกค้า</td>
                    <td className="text-nowrap">คลังสินค้า</td>
                    <td className="text-nowrap text-end">ยอดเงิน</td>
                    <td className="text-nowrap text-end">ยอดรวมสุทธิ</td>
                    <td className="text-nowrap text-center">รูปแบบการชำระ</td>
                    <td className="text-nowrap text-center">สถานะ</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td
                        className="text-nowrap"
                        onClick={() => {
                          if (
                            item.status === "รอชำระ" &&
                            item.withdrawal_type !== "เบิกแจ้งซ่อม"
                          ) {
                            window.location.href =
                              "/payment/payments?type=create&id=" + item.uid;
                          }
                        }}
                      >
                        {item.updated_at ? format_date(item.updated_at) : ""}
                      </td>
                      <td
                        className="text-nowrap"
                        onClick={() => {
                          if (
                            item.status === "รอชำระ" &&
                            item.withdrawal_type !== "เบิกแจ้งซ่อม"
                          ) {
                            window.location.href =
                              "/payment/payments?type=create&id=" + item.uid;
                          }
                        }}
                      >
                        {item.document_no}
                      </td>
                      <td
                        className="text-nowrap"
                        onClick={() => {
                          if (
                            item.status === "รอชำระ" &&
                            item.withdrawal_type !== "เบิกแจ้งซ่อม"
                          ) {
                            window.location.href =
                              "/payment/payments?type=create&id=" + item.uid;
                          }
                        }}
                      >
                        {item.customer?.full_name || "-"}
                      </td>
                      <td
                        className="text-nowrap"
                        onClick={() => {
                          if (
                            item.status === "รอชำระ" &&
                            item.withdrawal_type !== "เบิกแจ้งซ่อม"
                          ) {
                            window.location.href =
                              "/payment/payments?type=create&id=" + item.uid;
                          }
                        }}
                      >
                        {item.warehouse?.name || "-"}
                      </td>
                      <td
                        className="text-nowrap text-end"
                        onClick={() => {
                          if (
                            item.status === "รอชำระ" &&
                            item.withdrawal_type !== "เบิกแจ้งซ่อม"
                          ) {
                            window.location.href =
                              "/payment/payments?type=create&id=" + item.uid;
                          }
                        }}
                      >
                        {toFixed(item.amount) || "0.00"}
                      </td>
                      <td
                        className="text-nowrap text-end"
                        onClick={() => {
                          if (
                            item.status === "รอชำระ" &&
                            item.withdrawal_type !== "เบิกแจ้งซ่อม"
                          ) {
                            window.location.href =
                              "/payment/payments?type=create&id=" + item.uid;
                          }
                        }}
                      >
                        {toFixed(item.total_pay) || "0.00"}
                      </td>
                      <td
                        className="text-nowrap text-center"
                        onClick={() => {
                          if (
                            item.status === "รอชำระ" &&
                            item.withdrawal_type !== "เบิกแจ้งซ่อม"
                          ) {
                            window.location.href =
                              "/payment/payments?type=create&id=" + item.uid;
                          }
                        }}
                      >
                        {item.payment_type || "-"}
                      </td>
                      <td
                        className="text-nowrap text-center"
                        onClick={() => {
                          if (
                            item.status === "รอชำระ" &&
                            item.withdrawal_type !== "เบิกแจ้งซ่อม"
                          ) {
                            window.location.href =
                              "/payment/payments?type=create&id=" + item.uid;
                          }
                        }}
                      >
                        {item.status || "-"}
                      </td>
                      <td className="text-center align-middle wpx-100">
                        <div className="d-flex">
                          <BtnIcon
                            type="view"
                            onClick={() => {
                              window.location.href =
                                "/payment/payments?id=" +
                                item.uid +
                                "&type=view";
                            }}
                          />
                          <BtnIcon
                            type="print"
                            onClick={() => {
                              this.Print(item.uid, item.document_no, item);
                            }}
                          />
                          {item.status === "เสร็จสิ้น" && (
                            <BtnIcon
                              type="delete"
                              onClick={() => {
                                this.Delete(item.uid);
                              }}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
      </div>
    );
  }
}
